import { useForm } from "react-hook-form";
import { auth } from "./auth";
import { useNavigate } from "react-router-dom";
import loginScreenImage from "../../../assets/images/login-screen.png";
import logoAtomDark from "../../../assets/images/18a9c.svg";
import spendAnalysisIcon from "../../../assets/images/3a326.svg";
import riskGuardianIcon from "../../../assets/images/9e450.svg";
import supplierScorecardsIcon from "../../../assets/images/96c95.svg";
import inputIcon from "../../../assets/images/d95e0.svg";
import lockIcon from "../../../assets/images/lock.svg";
import invoicePaymentIcon from "../../../assets/images/Invoice.svg";
import purchaseIcon from "../../../assets/images/Purchase.svg";

interface LoginPageProps {
  onLogin: () => void;
}

export function LoginPage({ onLogin }: LoginPageProps) {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<{
    email: string;
    password: string;
  }>({
    defaultValues: { email: "", password: "" },
  });

  const submit = async (data: { email: string; password: string }) => {
    await new Promise((resolve) => setTimeout(resolve, 400));

    const success = await auth.login(data.email, data.password);

    if (success) {
      onLogin();
      navigate("/intelligence/spend");
    } else {
      alert("Invalid Credentials");
    }
  };

  return (
    <div className="screen-enter">
      <aside className="login-left-panel">
        <div aria-hidden className="login-left-bg-wrap">
          <img alt="" className="login-left-bg" src={loginScreenImage} />
          <div className="login-left-overlay" />
        </div>
        <div className="login-left-brand">
          <img alt="procure.ai" className="login-left-brand-icon" src={logoAtomDark} />
          <div className="login-left-brand-text">
            <span className="login-left-brand-procure">Procur</span>
            <span className="login-left-brand-ai">AI</span>
          </div>
        </div>

        <div className="login-left-content">
          <div className="login-left-headline-wrap">
            <p className="login-left-headline">
              Unlocking Insights in
            </p>
            <div className="login-left-headline-accent" />
          </div>

          <div className="login-left-pills">
            {[
              { icon: spendAnalysisIcon, label: "Spend" },
              { icon: riskGuardianIcon, label: "Sourcing" },
              { icon: supplierScorecardsIcon, label: "Contract" },
              { icon: purchaseIcon, label: "Purchase" },
              { icon: invoicePaymentIcon, label: "Invoice & Payment" }
            ].map((item) => (
              <div key={item.label} className="login-pill">
                <img alt="" className="login-pill-icon" src={item.icon} />
                <p className="login-pill-label">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </aside>

      <section className="login-right-panel">
        <div className="login-panel-inner">
          <div className="login-heading-block">
            <p className="login-heading-title">Welcome back</p>
            <p className="login-heading-subtitle">
              Sign in with your enterprise credentials
            </p>
          </div>

          <form onSubmit={handleSubmit(submit)} noValidate>
            <div className="login-fields">
              <div className="login-field-group">
                <label className="login-field-label" htmlFor="email">
                  Email Address
                </label>
                <div className="login-field-shell">
                  <img alt="" aria-hidden className="login-field-shell-img" src={inputIcon} />
                  <input
                    id="email"
                    className="login-field-input"
                    type="email"
                    placeholder="your@company.com"
                    autoComplete="email"
                    {...register("email")}
                  />
                </div>
              </div>

              <div className="login-field-group">
                <div className="login-field-top-row">
                  <label className="login-field-label" htmlFor="password">
                    Password
                  </label>
                </div>
                <div className="login-field-shell">
                  <img alt="" aria-hidden className="login-field-shell-img" src={lockIcon} />
                  <input
                    id="password"
                    className="login-field-input"
                    type="password"
                    placeholder="........"
                    autoComplete="current-password"
                    {...register("password")}
                  />
                </div>
                <a href="#" className="login-forgot-link">Forgot Password?</a>
              </div>
            </div>

            <div className="login-actions">
              <button
                type="submit"
                className="login-submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Signing in..." : "Sign In"}
              </button>

              <div className="login-or-divider">
                <span className="login-or-line" />
                <span className="login-or-label">or</span>
                <span className="login-or-line" />
              </div>

              <div className="login-secondary-actions">
                <button
                  type="button"
                  className="login-secondary-btn"
                  onClick={() =>
                    submit({
                      email: "admin@evalueserve.com",
                      password: "Evs@1234",
                    })
                  }
                  disabled={isSubmitting}
                >
                  Sign in with SSO
                </button>
                <button type="button" className="login-secondary-btn">
                  Sign in with Microsoft
                </button>
              </div>
            </div>
          </form>

          <div className="login-copyright-wrap">
            <p className="login-copyright">
              Copyright 2026. Evalueserve.com Pvt. Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
